import React, { useState } from "react";
import Traitement from "../pages/Traitement";
import PokEssais from "../pages/PokEssais";
import Gestion from "../pages/Gestion";
import Visionnement from "../pages/Visionnement";
import MiseEnEau from "../pages/MiseEnEau";
import Admin from "../pages/Admin";
import EntrainementIA from "../pages/EntrainementIA";

// Liste distincte de NAV (Layout.jsx) — chaque nouvel onglet ajouté à la nav principale doit
// aussi être ajouté ici, sinon il reste invisible dans les mini-nav des panneaux de la vue
// divisée (bug signalé par Jordan le 23/09/2026 : "POK" ajouté à NAV mais oublié ici).
const PAGES = [
  { id: "traitement",  label: "📈 Syrinix",       Component: Traitement },
  { id: "pok",         label: "⚙️ POK",           Component: PokEssais },
  { id: "gestion",     label: "🛠️ Gestion",       Component: Gestion },
  { id: "visionnement",label: "👁️ Visionnement",  Component: Visionnement },
  { id: "mee",         label: "💧 MEE",            Component: MiseEnEau },
  { id: "ia",          label: "🤖 IA",             Component: EntrainementIA },
  { id: "admin",       label: "🛡️ Admin",          Component: Admin },
];

export default function Panel({ defaultPage = "traitement" }) {
  const [activePage, setActivePage] = useState(defaultPage);
  const { Component } = PAGES.find(p => p.id === activePage) ?? PAGES[0];

  return (
    <div className="flex flex-col flex-1 min-w-0 min-h-0 border border-gray-200 rounded-xl bg-white shadow-sm overflow-hidden">
      {/* Mini nav */}
      <nav className="flex gap-1 px-3 py-2 border-b bg-gray-50 shrink-0 overflow-x-auto">
        {PAGES.map(({ id, label }) => (
          <button
            key={id}
            onClick={() => setActivePage(id)}
            className={`px-2.5 py-1 rounded-md text-xs font-medium whitespace-nowrap transition-colors ${
              activePage === id
                ? "bg-violet-600 text-white"
                : "text-gray-500 hover:bg-gray-200"
            }`}
          >
            {label}
          </button>
        ))}
      </nav>

      {/* Contenu scrollable */}
      <div className="flex-1 overflow-auto p-4">
        <Component />
      </div>
    </div>
  );
}
